<template>
  <v-container fluid grid-list-md>
    <!-- <v-dialog scrollable v-model="loading" persistent max-width="200"> -->
      <v-card v-if="loading">
        <v-card-title>{{ $t("globals.please_wait") }}</v-card-title>
        <v-card-text>
          <v-container fluid grid-list-md>
            <v-layout row justify-center>
              <v-flex xs12 sm6 md4 lg3>
                <v-progress-circular indeterminate></v-progress-circular>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    <!-- </v-dialog> -->
    <v-card style="display: flex; flex-direction: column" v-else>
      <v-card-title class="primary pa-2 pl-4 text-subtitle-1">
        <span class="white--text">{{ "#" + uploadName }}</span>
        <v-spacer></v-spacer>
        <v-icon dark @click="close">mdi-close</v-icon>
      </v-card-title>
      <v-card-text class="pa-2 pt-0" style="background-color: grey" v-if="file">
        <div class="filename pt-2 white--text">{{ file.FileName }}</div>

        <!-- Pdf Preview -->
        <div v-if="file.FileExtension.toLowerCase() === 'pdf'">
          <pdf-preview :fileItem="file" />
        </div>

        <!-- Image preview -->
        <div
          v-else-if="
            file.FileExtension.toLowerCase() === 'png' ||
              file.FileExtension.toLowerCase() === 'jpg' ||
              file.FileExtension.toLowerCase() === 'jpeg'
          "
          class="file-preview-container"
        >
          <v-img :src="'data:image/jpg;base64,' + file.Base64"></v-img>
        </div>

        <!-- text preview -->
        <div
          v-else-if="file.FileExtension.toLowerCase() === 'txt'"
          class="file-preview-container"
          style="font-size: 1em; overflow-y: auto"
        >
          {{ formatBase64ToText(file.Base64) }}
        </div>
        <v-card-text v-else class="file-preview-container">
          <h5 class="white--text">
            {{ $t("components.filepreview.no_preview") }}
          </h5>
        </v-card-text>
      </v-card-text>
    </v-card>
    <error-handler :error="error" />
  </v-container>
</template>

<script>
import ErrorHandler from "@/components/ErrorHandler.vue";
import PdfPreview from "@/components/Claims/PdfPreview.vue";
import { mapActions } from "vuex";
export default {
  components: {
    ErrorHandler,
    PdfPreview
  },
  props: ["uploadName", "fileId", "fileName"],
  data() {
    return {
      loading: false,
      error: null,
      file: null,
    };
  },
  async mounted() {
    console.log("mounted", this.fileId, this.uploadName);
    if (this.fileId !== null && this.fileId !== undefined) {
      try {
        this.loading = true;

        let file = (await this.getFile(this.fileId)).data;
        if (file[0] === '"') {
          file = file.slice(1, -1);
        }
        this.file = {
          FileName: this.fileName
        };
        this.file.Base64 = file;
        this.file.FileExtension = this.$helpers.fileExtension(
          this.file.FileName
        );
      } catch (error) {
        this.error = error;
      } finally {
        this.loading = false;
      }
    }
  },
  methods: {
    ...mapActions("documentsService", ["getFile"]),
    formatBase64ToText(base64Txt) {
      return atob(base64Txt);
    },
    close() {
      window.close();
    }
  },
};
</script>
